function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v48h25.44V32.14h-6.16v-7.36h6.16v-5.66c0-6.54 4.2-10.18 9.9-10.18 2.73 0 5.08.2 5.76.3v7.05l-3.96-.2c-3.1 0-3.87 1.38-3.87 3.6v5.1h7.27l-.56 7.35h-6.71V48H48V0H0z",
  fillRule: "evenodd"
})));